<template>
  <div class="page">
    <div class="layout-header">
      <div class="lyh_top">
        <div class="lyh_l">
          <img src="../../assets/img/log.jpg" class="telecom-logo"/>           
        </div>
        <div class="lyh_r">
            <div class="iccid">
              <div class="card-iccid">
                <span style="margin-right:3px">{{ $t('cardInfo.iccid') }}:</span>
                <span>{{propsParams.iccid}}</span>
              </div>
              <div class="switch" @click="switchCard">
                <img style="width:20px" :src="require('../../assets/svg/switch.svg')">
              </div>
            </div>
            <div class="expire">
              <span style="margin-right:3px">{{ $t('cardInfo.expiration') }}:</span>
              <span>2024-07-09</span>
            </div>
            <div class="status">
              <div class="card-status">
                <span style="margin-right:3px">{{ $t('cardInfo.status') }}:</span>
                <span style="color:#3bce9e">{{propsParams.cardStatus}}</span>
              </div>
              <div class="card-refresh">
                <img style="width:20px" :src="require('../../assets/svg/refresh.svg')">
              </div>
              <div class="card-kefu">
                <img style="width:1.66rem" :src="require('../../assets/svg/kefu.svg')">
              </div>
            </div>
        </div>
        <!-- <div class="lyh_r">
          <p class="sub-tlt"><span class="left">{{ $t('cardInfo.iccid') }}</span>{{propsParams.iccid}}</p>
          <p class="sub-tlt"><span class="left">{{ $t('cardInfo.expiration') }}</span>{{propsParams.expireTime}}</p>
        </div> -->
      </div>
      <!-- <div class="status-line">
        <div class="status-wrap">
          <p>{{propsParams.cardStatus}}</p>
        </div>
        <div class="mark-box">
          <nut-button @click="refresh()">{{ $t('cardInfo.refresh') }}</nut-button>
        </div>
      </div> -->
     
    </div>
    <div class="detail-flow">
      <div class="residual-flow">
        <span style="margin-right:5px">{{ $t('cardInfo.residualFlow') }}:</span>
        <span>{{zjdata.surplusFlow}}</span>
      </div>
      <div class="other-flow">
        <div>
          <span style="margin-right:5px">{{ $t('cardInfo.totalFlow') }}:</span>
          <span>{{zjdata.totalFlow}}</span>
        </div>
        <div>
          <span style="margin-right:5px">{{ $t('cardInfo.used') }}:</span>
          <span>{{zjdata.useFlow}}</span>
        </div>
      </div>
    </div>
    <div class="detail-box">
      <nut-tab line-width="20" @tab-switch="tabSwitch">
        <nut-tab-panel v-for="(item,index) in this.$t('cardInfo.lists')" :key="index" :tab-title="item">
          <ul style="padding-bottom: 85px;">
            <li class="li_class" v-for="(item1,index1) in packageList" :key="index1">
              <div class="li_class_left">
                <span>{{item1.productName}}</span>
                <div>
                  <span style="margin-right:5px;color:#A5A5A5">{{ $t('cardInfo.validity') }}:</span>
                  <span>{{item1.endTime}}</span>
                </div>
              </div>
              <nut-progress :percentage="item1.usePercent" stroke-color="#1296db" stroke-width="5" status="active" v-if="item1.monthFlow != '畅享'"></nut-progress>
              <div class="is-state" v-if="item1.monthFlow == '畅享'">
              </div>
              <div class="div-yl">
                <span>{{item1.useFlow}}/{{item1.monthFlow}}</span>
                <span style="font-size:14px">{{item1.orderNum}}</span>
              </div>  
            </li>
          </ul>
        </nut-tab-panel>
      </nut-tab>
    </div>
    <div class="div_tips">
      <div class="div_tips_wrap">
        <div class="btn-line">
          <nut-button @click="handlePay()">{{$t('cardInfo.recharge')}}</nut-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { wx_international } from "@/api/api.js"; //获取卡详情
import { wx_internationalFlow } from "@/api/api.js"; //获取卡流量数据
import { wx_internationalProduct } from "@/api/api.js"; //获取卡流量各个状态的数据
export default {
  data() {
    return {
      // 获取卡信息
      zjdata:{},
      propsParams:{},
      mobileType: 1,
      // tab切换
      // lists:this.$t('cardInfo.lists'),
      packageList:[],
    };
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
  },
  methods: {
    // 卡状态转换
    transferCardStatus(status) {
      let obj = {
        1: "Stock",
        2: "ToBeActivated",
        3: "Testable",
        4: "Activated",
        5: "Down",
        6: "PreClosingAccount",
        7: "Pre-saleAccount",
        8: "ShutdownWarrantyNumber",
        9: "CardReplenished",
      };
      return obj[status];
    },
    switchCard(){
      this.$router.push('/international/cardLoop')
    },
    // 跳转咨询客服
    jumpService(){
      window.location.href="https://kefu.easemob.com/webim/im.html?configId=8397c462-d657-4bd3-b14d-7794be9148e4";
    },
    // 去充值
    handlePay(){
      this.$router.push({
            path: "/international/cardPlans",
            query: {
          iccid: this.$route.query.iccid,
        }
      })
    },
    //获取详情
    getCard(){
      let params= {
        iccid:this.$route.query.iccid,
      };
      wx_internationalFlow(params).then(res=>{
        if(res.data.code == 200){
          this.zjdata =  res.data.data;
        }
      });
      wx_international(params).then(res => {
        if(res.data.code == 200){
          this.propsParams = res.data.data;
          this.propsParams.cardStatus = this.transferCardStatus(this.propsParams.showStatus);
          if(this.propsParams.expireTime == null){
            this.propsParams.expireTime == "";
          }else{
            this.propsParams.expireTime = this.propsParams.expireTime.substr(0,10);
          };
        }else{
          this.$toast.fail(res.data.message);
        }
      })
    },
    // tab切换
    // 1 生效中 2 未生效 3.已失效
    tabSwitch(index = 0) {
      let params= {
        iccid:this.$route.query.iccid,
        status:index + 1
      };
      wx_internationalProduct(params).then(res =>{
        if(res.data.code == 200){
          this.packageList = res.data.data;
          this.packageList.map(item =>{
            if(item.productName == null){
              this.propsParams.expireTime == "";
            }else{
              item.productName = item.productName.substr(0,15);
            };
            item.usePercent = (item.usePercent * 100).toFixed(0);
            if(item.endTime == null){
              item.endTime = '无';
            }else{
              item.endTime = item.endTime.substr(0,10);
            }
          })
        }else{
          this.packageList = [];
        }
      })
    },
    // 刷新状态
    refresh(){
      location.reload();
    },
    // 初始化数据
    initData(){
      
    },
  },
  mounted(){
    this.$i18n.locale = this.language;
    window.document.title = this.$t('cardLoop.title');
    this.getCard();
    this.tabSwitch();
    this.initData();
    this.$toast.loading('Loading...',{ 
      duration:800,
      coverColor: "rgba(0,0,0,0.5)",
      closeOnClickOverlay: true,
      loadingRotate:true
    });
  }
};
</script>
<style scoped lang="less">
  .page{
    background: #fafafa;
    font-family: PingFangSC-Medium,PingFang SC;
    // 页面开始   实名的弹窗
    .layout-header{
      margin-bottom: 5px;
      .lyh_top{
        padding: 10px 6px 5px  6px;
        width: 100%;
        display: flex;
        align-items: center;
        background: #ffffff;
        .lyh_l{
          max-width: 25%;
          text-align: center;
          position: relative;
          top:-1px
        }
        .lyh_r{
          margin-left: 15px;
          line-height: 25px;
          font-size: 15px;
          .iccid{
            display: flex;
            align-items: center;
            font-weight: 600;
            .switch{
              margin-left: 8px;
            }
          }
          .status{
            display: flex;
            align-items: center;
            // justify-content: space-between;
            .card-refresh{
              margin: 0px 0px 0px 1.3rem;
            }
            .card-kefu{
              margin: 0px 0px 0px 1.3rem;
            }
          }


          .title {
            font-size: 18px;
          }
          .sub-tlt {
            font-size: 16px;
            white-space: nowrap;
          }
        }
      }
      .status-line {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        padding: 0 15px;
        box-sizing: border-box;
        background: #ffffff;
        .status-wrap {
          display: flex;
          p{
            padding: 0 2px;
            height: 22px;
            line-height: 20px;
            text-align: center;
            border: 1px solid #3bce9e;
            color: #3bce9e;
            font-size: 12px;
            border-radius: 3px;
            &:first-child {
              margin-right: 5px;
            }
          }
        }
        .mark-box {
          span{
            display: inline-block;
            width: 55px;
            text-align: center;
            height: 22px;
            line-height: 22px;
            padding: 0;
            font-size: 12px;
            border-radius: 3px;
            background: #F94040;
            color: #ffffff;
            position: relative;
            top: 1px;
          }
          button {
            margin-left: 4px;
            // width: 34px;
            height: 22px;
            line-height: 22px;
            padding: 0 3px;
            font-size: 12px;
            border-radius: 3px;
          }
        }
      }
    }
    .detail-flow{
      margin: 6px 6px;
      border-radius: 10px;
      border: 1px solid #1296db;
      color: #1296db;
      background: #fff;
      padding: 20px 6px;
      box-sizing: border-box;
      position: relative;
      display: flex;
      flex-direction: column;
      .residual-flow{
        text-align: center;
        font-size: 1.4rem;
        font-weight: 600;
      }
      .other-flow{
        display: flex;
        justify-content: space-between;
        font-size: 1.2rem;
        margin-top: 16px;
      }
      
      
    }
    .detail-box{
      margin-top: 10px;
      margin: 10px 6px;
      // width: 100%;
      position: relative;
      /deep/ .nut-tab-link {
        font-size: 1.1rem;
      }
      /deep/ .nut-tab-title {
        height: 40px;
        line-height: 40px;
      }
      .li_class{
        padding: 13px 13px;
        background: #fff;
        width: 100%;
        // height: 100px;
        font-size: 1.1rem;
        border-bottom: 2px solid #EDEDED;
        .li_class_left{
          display: flex;
          justify-content: space-between;
          align-items: center;
          span{
            margin-top: 5px;
          }
        }
        .is-state{
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 15px;
          span{
            display: inline-block;
            width: 50px;
            text-align: center;
          }
          /deep/ .nut-progress{
            width: 75%;
          }
        }
        
        /deep/ .nut-progress{
          margin: 5px 0;
          // margin-top: 8px;
          .nut-progress-text{
            // color: #999;
          }
          .nut-progress-outer{
            background-color:#EDEDED
          }
        }
        .div-yl{
          // margin-top: 8px;
          display: flex;
          justify-content: space-between;
        }
      }
      /deep/ .nut-tab{
        padding: 0;
        border: none;
      }
      /deep/ .nut-tab-item{
        // height: auto;
        height: 200px;
        padding: 0;
      }
      /deep/ .nav-bar{
        background: #1296db!important;
      }
      /deep/ .nut-tab-active{
        .nut-tab-link{
          color:#1296db !important;
        }
      }
    }
    .div_tips{
      width: 100%;
      background: #F8F8F8;
      position: fixed;
      bottom: 0;
      padding: 10px;
      .div_tips_wrap {
        position: relative;
        p{
          .shutdownNumber{
            
            font-size: 13px;
            border: none;
            border-bottom: 1px solid #0186D3;
            background: #F8F8F8;
            color:#0186D3;
          }
        }
        .p_tips{
          color: #F94040;
          font-size: 14px;
        }
        .btn-line {
          margin: 10px 0 5px;
          display: flex;
          justify-content: center;
          button{
            border-radius: 10px;
            width: 55%;
            margin-left: 0;
            font-size: 14px;
            height: 45px;
            line-height: 45px;
            // background:#F94040 !important ;
            border: 1px solid #1296db !important;
          }
        }
      }
    }
    .nut-button{
      margin-left: 40px;
      background: #1296db;
    }
  }
  @-webkit-keyframes masked-animation {
    0%{
      background-position: 0 0;
    }
    100%{
      background-position: -100% 0;
    }
  }
  @media screen  and (max-width: 320px) {
    .li_class_left{
      font-size: 12px;
    }
    .div-yl{
      font-size: 12px !important;
    }
  }
</style>

